import React, { useState } from "react";
import { Callout } from "@octopusdeploy/design-system-components";
import { consumeActionDroppedByReauth } from "client/reauthDroppedActionNotice";

// Shown once after a mutating request was discarded by a 401-triggered reauth reload.
// The flag is consumed (read-and-cleared) on first render.
const SessionReauthNotice = () => {
  const [show, setShow] = useState(consumeActionDroppedByReauth);

  if (!show) return null;

  return (
    <Callout
      type="warning"
      title="Your session was refreshed"
      canClose
      onClose={() => setShow(false)}
    >
      Your last change may not have been saved because your session had expired.
      Please check, and repeat the action if it didn't take effect.
    </Callout>
  );
};

export default SessionReauthNotice;
